<template>
  <div class="allBox">
    <div class="tabBox">
      <div :class="state == '0' ? 'active' : ''" @click.stop="tabClick(0)">
        我发出的评论
      </div>
      <div :class="state == '1' ? 'active' : ''" @click.stop="tabClick(1)">
        我收到的评论
      </div>
    </div>

    <!-- 数据列表 -->
    <div class="bigBox">
      <div v-if="state == 0 && sendList.length > 0">
        <div class="seandBox">
          <div @click.stop="editClick">{{ editStatus ? "完成" : "编辑" }}</div>
        </div>
      </div>
      <div v-if="state == 1">
        <div class="topBox">
          <div class="tabSmallBox">
            <div
              class="tab"
              :class="smallState == '0'"
              v-if="show"
              @click.stop="smallTabClick(0)"
            >
              查看全部
            </div>
            <div
              class="tab"
              :class="smallState == '1'"
              v-if="!show"
              @click.stop="smallTabClick(1)"
            >
              只看未读
            </div>
            <div class="tab" @click.stop="readClick">全部标记为已读</div>
          </div>
        </div>
      </div>

      <!-- 我发出的评论 -->
      <div v-if="state == 0">
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="getListHandle"
        >
          <van-radio-group v-model="radio">
            <div v-for="(item, index) in sendList" :key="index">
              <div class="contentItem">
                <div
                  class="selectBox"
                  v-if="editStatus"
                  @click.stop="radioClick(item.SourceContent.ContentType)"
                >
                  <van-radio
                    shape="square"
                    checked-color="#EB4E4E"
                    :name="item.RecordId"
                    icon-size="15px"
                  ></van-radio>
                </div>
                <div
                  class="listBox"
                  v-if="item.CommentContent && item.SourceContent"
                >
                  <div class="smallBox">
                    <van-image
                      fit="cover"
                      :src="item.CommentContent.Photo"
                      round
                      error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                    />
                    <div class="name">{{ item.CommentContent.NickName }}</div>
                    <div class="time">
                      {{ item.CommentContent.CreateTime | formatCreateTime }}
                    </div>
                  </div>
                  <div class="contentBox">
                    <div class="text-box">
                      <div class="content">
                        {{ item.CommentContent.Content }}
                      </div>
                      <div class="banBox" v-if="item.CommentContent.IsDeleted">
                        <img src="../../../static/images/member/icon_x.png" />
                        <div>已被作者屏蔽</div>
                      </div>
                    </div>
                    <div class="commentBox">
                      <div class="hot">
                        评论于：{{ item.SourceContent.Title }}
                      </div>
                      <div
                        :class="
                          item.open
                            ? 'iconfont icon-arrow-down'
                            : 'iconfont icon-arrow-up'
                        "
                        style="color: #999; font-size: 9px; margin-left: 5px"
                        @click.stop="openClick(item.RecordId)"
                      ></div>
                    </div>
                    <div
                      class="contentSmall"
                      v-if="!item.open"
                      @click.stop="
                        toTwoDetail(
                          item.SourceContent.ContentType,
                          item.SourceContent.ContentID,
                          item.SourceContent.HeadMemberId
                        )
                      "
                    >
                      <van-image
                        fit="cover"
                        class="newsImg"
                        :src="item.SourceContent.Thumbnail"
                        v-if="item.SourceContent.Thumbnail"
                      />
                      <div class="comRight">
                        <div class="comment overFlowTwo">
                          {{ item.SourceContent.Title }}
                        </div>
                        <div class="goods">
                          <div style="margin-right: 7px">
                            {{ item.SourceContent.LikeNum }} 赞
                          </div>
                          <div>{{ item.SourceContent.CommentNum }} 评论</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-radio-group>
        </van-list>
      </div>

      <!-- 我收到的评论 -->
      <div v-if="state == 1">
        <!-- 查看全部 -->
        <van-list
          v-if="smallState == 0"
          v-model="rloading"
          :finished="rfinished"
          :error.sync="rerror"
          error-text="请求失败，点击重新加载"
          @load="getAllListHandle"
        >
          <div
            class="receieveBox"
            v-for="(item, index) in receieveList"
            :key="index"
          >
            <div v-if="item.SourceContent && item.CommentContent">
              <div class="smallBox">
                <van-image
                  :src="item.CommentContent.Photo"
                  round
                  error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                />
                <div class="name">{{ item.CommentContent.NickName }}</div>
                <div class="time">
                  {{ item.CommentContent.CreateTime | formatCreateTime }}
                </div>
              </div>
              <div class="contentBox">
                <div class="text-box">
                  <div
                    :class="item.CommentContent.IsReaded ? 'content' : 'bold'"
                  >
                    {{ item.CommentContent.Content }}
                  </div>
                  <!-- 屏蔽判断 -->
                  <div class="banBox" v-if="item.CommentContent.IsDeleted">
                    <img src="../../../static/images/member/icon_x.png" />
                    <div>已被作者屏蔽</div>
                  </div>
                </div>

                <!-- 回复框 -->
                <div v-if="item.showText">
                  <textarea class="textBox" v-model="replyText"></textarea>
                  <div class="textBtn">
                    <div @click.stop="cancelTextarea(item.RecordId)">取消</div>
                    <div
                      @click.stop="
                        confirmBtn(
                          item.RecordId,
                          item.SourceContent.ContentType
                        )
                      "
                    >
                      确认回复
                    </div>
                  </div>
                </div>

                <!-- 确认回复 -->
                <div v-if="item.ReplyList.length > 0">
                  <div
                    class="confirmBox"
                    v-for="(inner, innex) in item.ReplyList"
                    :key="innex"
                  >
                    <div class="replyTime">
                      {{ inner.CreateTime | formatCreateTime }} 回复：
                    </div>
                    <div class="replyContent">{{ inner.Content }}</div>
                    <div
                      class="delete"
                      @click.stop="
                        deleteClick(
                          inner.RecordId,
                          item.SourceContent.ContentType
                        )
                      "
                    >
                      删除
                    </div>
                  </div>
                </div>

                <!-- 收缩Box -->
                <div class="commentBox">
                  <div class="hot">评论于：{{ item.SourceContent.Title }}</div>
                  <div
                    :class="
                      item.open
                        ? ' iconfont icon-arrow-down'
                        : ' iconfont icon-arrow-up'
                    "
                    style="color: #999; font-size: 9px; margin-left: 5px"
                    @click.stop="openRClick(item.RecordId)"
                  ></div>
                </div>
                <!-- 收缩内容 -->
                <div
                  class="contentSmall"
                  v-if="!item.open"
                  @click.stop="
                    toTwoDetail(
                      item.SourceContent.ContentType,
                      item.SourceContent.ContentID,
                      item.SourceContent.HeadMemberId
                    )
                  "
                >
                  <van-image
                    fit="cover"
                    class="newsImg"
                    :src="item.SourceContent.Thumbnail"
                    v-if="item.SourceContent.Thumbnail"
                  />
                  <div class="comRight">
                    <div class="comment overFlowTwo">
                      {{ item.SourceContent.Title }}
                    </div>
                    <div class="goods">
                      <div style="margin-right: 7px">
                        {{ item.SourceContent.LikeNum }} 赞
                      </div>
                      <div>{{ item.SourceContent.CommentNum }} 评论</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 回复屏蔽按钮 -->
              <div class="rightBtnBox">
                <div
                  class="rightBtn"
                  v-if="item.CommentContent.IsDeleted"
                  @click.stop="
                    cancelBan(item.RecordId, item.SourceContent.ContentType)
                  "
                >
                  取消屏蔽
                </div>
                <div class="rightBtn" v-else>
                  <div @click.stop="showTextarea(item.RecordId)">回复</div>
                  <div
                    @click.stop="
                      clickBan(item.RecordId, item.SourceContent.ContentType)
                    "
                  >
                    屏蔽
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>

        <!-- 只看未读的 -->
        <van-list
          v-if="smallState == 1"
          v-model="uloading"
          :finished="ufinished"
          :error.sync="uerror"
          error-text="请求失败，点击重新加载"
          @load="getUnListHandle"
        >
          <div class="receieveBox" v-for="(item, index) in unlist" :key="index">
            <div v-if="item.SourceContent && item.CommentContent">
              <div class="smallBox">
                <van-image
                  fit="cover"
                  class="head"
                  :src="item.CommentContent.Photo"
                />
                <div class="name">{{ item.CommentContent.NickName }}</div>
                <div class="time">
                  {{ item.CommentContent.CreateTime | formatCreateTime }}
                </div>
              </div>
              <div class="contentBox">
                <div class="text-box">
                  <div class="bold">{{ item.CommentContent.Content }}</div>
                  <div class="banBox" v-if="item.CommentContent.IsDeleted">
                    <img src="../../../static/images/member/icon_x.png" />
                    <div>已被作者屏蔽</div>
                  </div>
                </div>
                <div v-if="item.showText">
                  <textarea class="textBox" v-model="replyText"></textarea>
                  <div class="textBtn">
                    <div @click.stop="cancelTextarea(item.RecordId)">取消</div>
                    <div
                      @click.stop="
                        confirmBtn(
                          item.RecordId,
                          item.SourceContent.ContentType
                        )
                      "
                    >
                      确认回复
                    </div>
                  </div>
                </div>
                <div v-if="item.ReplyList.length > 0">
                  <div
                    class="confirmBox"
                    v-for="(inner, innex) in item.ReplyList"
                    :key="innex"
                  >
                    <div class="replyTime">
                      {{ inner.CreateTime | formatCreateTime }} 回复：
                    </div>
                    <div class="replyContent">{{ inner.Content }}</div>
                    <div
                      class="delete"
                      @click.stop="
                        deleteClick(
                          inner.RecordId,
                          item.SourceContent.ContentType
                        )
                      "
                    >
                      删除
                    </div>
                  </div>
                </div>
                <div class="commentBox">
                  <div class="hot">评论于：{{ item.SourceContent.Title }}</div>
                  <div
                    :class="
                      item.open
                        ? 'iconfont icon-arrow-down'
                        : ' iconfont icon-arrow-up'
                    "
                    style="color: #999; font-size: 9px; margin-left: 5px"
                    @click.stop="openNoClick(item.RecordId)"
                  ></div>
                </div>
                <div
                  class="contentSmall"
                  v-if="!item.open"
                  @click.stop="
                    toTwoDetail(
                      item.SourceContent.ContentType,
                      item.SourceContent.ContentID,
                      item.SourceContent.HeadMemberId
                    )
                  "
                >
                  <van-image
                    fit="cover"
                    class="newsImg"
                    :src="item.SourceContent.Thumbnail"
                    v-if="item.SourceContent.Thumbnail"
                  />
                  <div class="comRight">
                    <div class="comment overFlowTwo">
                      {{ item.SourceContent.Title }}
                    </div>
                    <div class="goods">
                      <div style="margin-right: 7px">
                        {{ item.SourceContent.LikeNum }} 赞
                      </div>
                      <div>{{ item.SourceContent.CommentNum }} 评论</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rightBtnBox">
                <div
                  class="rightBtn"
                  v-if="item.CommentContent.IsDeleted"
                  @click.stop="
                    cancelBan(item.SourceContent.ContentType, item.RecordId)
                  "
                >
                  取消屏蔽
                </div>
                <div class="rightBtn" v-else>
                  <div @click.stop="showTextarea(item.RecordId)">回复</div>
                  <div
                    @click.stop="
                      clickBan(item.RecordId, item.SourceContent.ContentType)
                    "
                  >
                    屏蔽
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>

      <!-- 没有数据 -->
      <div
        class="noDataBox"
        v-if="
          (state == 0 && sendList.length == 0) ||
          (state == 1 && smallState == 0 && receieveList.length == 0) ||
          (smallState == 1 && unlist.length == 0)
        "
      >
        <span class="iconfont icon-kong"></span>
        <div>暂无内容</div>
      </div>

      <div class="operation-box" v-if="editStatus">
        <div class="clearBtn" @click.stop="clearAllHandle">一键清空</div>
        <div class="deleteBtn" @click.stop="delectHandle">删除</div>
      </div>
    </div>
  </div>
</template>
<script>
import { formatDate } from "@/utils/date";
import { List, Radio, RadioGroup, Image, Toast } from "vant";
import {
  getMyPostComments,
  getMyReceivedComment,
  getMyReceivedUnReadComment,
  updateAllCommentRead,
  deleteMemberComment,
  deleteAllMyPostComment,
  createReplyComment,
  updateCommentShieldStatus,
} from "@/api/member";
export default {
  name: "comment",
  components: {
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-list": List,
    "van-image": Image,
    Toast,
  },
  data() {
    return {
      show: false, //只看未读 全部切换
      state: 0, //0我发出的评论  1我收到的评论
      smallState: 0, //0全部 1未读
      editStatus: false, //编辑
      radio: "", //单选框
      type: "", //原内容类型 1文章 2视频
      replyText: "", //回复内容

      //发出评论列表
      sendList: [],
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,

      //收到的评论--查看全部
      receieveList: [
        {
          open: false, //收缩效果
          showText: false, //回复弹窗
          ban: false, //屏蔽
        },
      ],
      rloading: false,
      rfinished: false,
      smallPageIndex: 1,
      smallTotal: 0,
      rerror: false,

      //收到的评论--未读
      unlist: [],
      uloading: false,
      ufinished: false,
      unPageIndex: 1,
      unTotal: 0,
      uerror: false,
    };
  },
  filters: {
    formatCreateTime(time) {
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
  methods: {
    //点击屏蔽
    clickBan(id, type) {
      var list = this.receieveList;
      var data = {
        ContentType: type,
        RecordId: id,
        Status: true,
      };
      updateCommentShieldStatus(data).then((res) => {
        list.forEach((item, index) => {
          if (list[index].RecordId == id) {
            item.CommentContent.IsDeleted = true;
          }
        });
        this.receieveList = list;
      });
    },

    //取消屏蔽
    cancelBan(id, type) {
      var list = this.receieveList;
      var data = {
        ContentType: type,
        RecordId: id,
        Status: false,
      };
      updateCommentShieldStatus(data).then((res) => {
        list.forEach((item, index) => {
          if (list[index].RecordId == id) {
            item.CommentContent.IsDeleted = false;
          }
        });
        this.receieveList = list;
      });
    },
    //点击回复
    showTextarea(id) {
      this.replyText = "";
      var list = this.receieveList;
      var newList = [];
      list.map((item, index) => {
        newList.push(
          Object.assign({}, item, {
            showText: item.showText,
          })
        );
      });
      newList.forEach((item, index) => {
        if (newList[index].RecordId == id) {
          newList[index].showText = !newList[index].showText;
        }
      });
      this.receieveList = newList;
    },

    //取消评论
    cancelTextarea(id) {
      var list = this.receieveList;
      var newList = [];
      list.map((item, index) => {
        newList.push(
          Object.assign({}, item, {
            showText: item.showText,
          })
        );
      });
      newList.forEach((item, index) => {
        if (newList[index].RecordId == id) {
          newList[index].showText = false;
        }
      });
      this.receieveList = newList;
    },

    //确认回复
    confirmBtn(id, type) {
      var that = this;
      var data = {
        RecordId: id,
        ContentType: type,
        Content: this.replyText,
      };
      createReplyComment(data).then((res) => {
        Toast("回复成功");
        that.smallPageIndex = 1;
        that.receieveList = [];
        that.getAllListHandle();
      });
    },

    //点击删除回复
    deleteClick(id, type) {
      var that = this;
      var data = { ContentType: type, RecordId: id };
      deleteMemberComment(data).then((res) => {
        that.Common.showMsg("确认删除数据吗？", function () {
          that.smallPageIndex = 1;
          that.receieveList = [];
          that.getAllListHandle();
        });
      });
    },

    //展开收缩点击-(我发出的评论)
    openClick(id) {
      var list = this.sendList;
      var newList = [];
      //添加新属性进列表
      list.map((item, index) => {
        newList.push(
          Object.assign({}, item, {
            open: item.open,
          })
        );
      });
      newList.forEach((item, index) => {
        if (newList[index].RecordId == id) {
          newList[index].open = !newList[index].open;
        }
      });
      this.sendList = newList;
    },

    //展开收缩点击-(我收到的评论-全部)
    openRClick(id) {
      var list = this.receieveList;
      var newList = [];
      //添加新属性进列表
      list.map((item, index) => {
        newList.push(
          Object.assign({}, item, {
            open: item.open,
          })
        );
      });
      newList.forEach((item, index) => {
        if (newList[index].RecordId == id) {
          newList[index].open = !newList[index].open;
        }
      });
      this.receieveList = newList;
    },

    //展开收缩点击-(我收到的评论-未读)
    openNoClick: function (e) {
      var that = this;
      var id = e.currentTarget.dataset.id;
      var list = that.data.unlist;
      var newList = [];
      //添加新属性进列表
      list.map((item, index) => {
        newList.push(
          Object.assign({}, item, {
            open: item.open,
          })
        );
      });
      newList.forEach((item, index) => {
        if (newList[index].RecordId == id) {
          newList[index].open = !newList[index].open;
        }
      });
      this.unlist = newList;
    },

    //跳转详情
    toTwoDetail(type, id, mid) {
      if (type == 1) {
        this.$router.push({
          path: "/articleDetail",
          query: { id: id, mid: mid },
        });
      } else if (type == 2) {
        this.$router.push({
          path: "/videoDetail",
          query: { id: id, mid: mid },
        });
      } else if (type == 6) {
        //图文动态
        this.$router.push({
          path: "/trendDetails",
          query: { tid: id },
        });
      } else if (type == 7) {
        this.$router.push({
          path: "/videoDetails",
          query: { vid: id },
        });
      } else {
      }
    },

    //点击编辑
    editClick() {
      this.editStatus = !this.editStatus;
    },

    //radio点击
    radioClick(type) {
      this.type = type;
    },

    //单选删除数据
    delectHandle() {
      var that = this;
      var data = { ContentType: this.type, RecordId: this.radio };
      deleteMemberComment(data).then((res) => {
        that.Common.showMsg("确认删除数据吗？", function () {
          that.pageIndex = 1;
          that.sendList = [];
          that.getListHandle();
        });
      });
    },

    //全部标记为已读
    readClick() {
      var that = this;
      updateAllCommentRead().then((res) => {
        setTimeout((res) => {
          Toast("设置成功");
          setTimeout((res) => {
            if (that.smallState == 1) {
              that.unPageIndex = 1;
              that.unlist = [];
            } else {
              that.smallPageIndex = 1;
              that.receieveList = [];
              that.getAllListHandle();
            }
          }, 1000);
        }, 0);
      });
    },

    //全部清空
    clearAllHandle() {
      deleteAllMyPostComment().then((res) => {
        this.Common.showMsg("确认清空数据吗？", function () {
          this.pageIndex = 1;
          this.sendList = [];
          this.getListHandle();
        });
      });
    },

    //tab切换
    tabClick(n) {
      this.state = n;
      if (this.state == 0) {
        this.pageIndex = 1;
        this.loading = true;
        if (this.loading) {
          this.getListHandle();
        }
      } else if (this.state == 1) {
        this.unlist = [];
        this.getAllListHandle();
      }
    },

    //smallTab切换
    smallTabClick(n) {
      this.smallState = n;
      if (this.smallState == 0) {
        this.show = false;
        this.smallState = 0;
        this.smallPageIndex = 1;
        this.receieveList = [];
        this.getAllListHandle();
      } else {
        this.show = true;
        this.unPageIndex = 1;
        this.unlist = [];
        this.uloading = true;
        if (this.uloading) {
          this.getUnListHandle();
        }
      }
    },

    //获取我发出的评论
    getListHandle() {
      var that = this;
      var data = {
        Page: {
          PageIndex: that.pageIndex,
          PageSize: 10,
        },
      };
      getMyPostComments(data).then((res) => {
        if (that.pageIndex == 1) {
          that.sendList = [...res.Data.List];
        } else {
          that.sendList = [...that.sendList, ...res.Data.List];
        }
        that.total = res.Data.Total;
        that.pageIndex += 1;
        // 加载状态结束
        that.loading = false;
        // 数据全部加载完成
        if (that.sendList.length >= that.total) {
          that.finished = true;
        }
      });
    },

    //获取我收到的评论--查看全部
    getAllListHandle() {
      var that = this;
      var data = {
        Page: {
          PageSize: 10,
          PageIndex: that.smallPageIndex,
        },
      };
      getMyReceivedComment(data).then((res) => {
        if (that.smallPageIndex == 1) {
          that.receieveList = [...res.Data.List];
        } else {
          that.receieveList = [...that.receieveList, ...res.Data.List];
        }
        that.smallTotal = res.Data.Total;
        that.smallPageIndex += 1;
        // 加载状态结束
        that.rloading = false;
        // 数据全部加载完成
        if (that.receieveList.length >= that.smallTotal) {
          that.rfinished = true;
        }
      });
    },

    //获取我收到的评论--查看未读
    getUnListHandle() {
      var that = this;
      var data = {
        Page: {
          PageSize: 10,
          PageIndex: that.unPageIndex,
        },
      };
      getMyReceivedUnReadComment(data).then((res) => {
        if (that.unPageIndex == 1) {
          that.unlist = [...res.Data.List];
        } else {
          that.unlist = [...that.unlist, ...res.Data.List];
        }
        that.unTotal = res.Data.Total;
        that.unPageIndex += 1;
        // 加载状态结束
        that.uloading = false;
        // 数据全部加载完成
        if (that.unlist.length >= that.unTotal) {
          that.ufinished = true;
        }
      });
    },
  },
  mounted() {
    if (this.$route.query.type == 1) {
      this.state = 1;
    }
  },
};
</script>
<style scoped src="../../../static/css/comment.css"></style>
